var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 76,
    viewBox: "0 0 58 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_218_1410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7521 0C36.9757 1.26456 40.3647 3.92013 43.6273 6.72745C48.2556 10.7488 52.4539 15.1747 55.7165 20.41C57.1075 22.6103 57.8409 24.9371 57.8156 27.5927C57.7398 42.9191 57.7903 58.2709 57.7903 73.5973C57.7903 73.9514 57.7903 74.2802 57.7398 74.6343C57.6133 75.4436 57.1328 75.8988 56.3235 75.9747C56.0705 76 55.8176 75.9747 55.59 75.9747C37.8103 75.9747 20.0053 75.9747 2.22562 75.9747C0.505824 75.9747 0.0252912 75.4942 0.0252912 73.7744C0 49.9248 0 26.0499 0 2.20033C0 1.23927 0.202329 0.42995 1.1381 0H32.7521ZM3.08552 72.9145H54.7301V72.2822C54.7301 56.9052 54.7301 41.5028 54.7301 26.1258C54.7301 25.8223 54.7048 25.5441 54.6795 25.2406C54.6037 24.583 54.3255 24.3048 53.592 24.3301C47.598 24.3807 41.6293 24.3301 35.6353 24.3301C33.9661 24.3301 33.4855 23.8496 33.4855 22.1551C33.4855 16.4646 33.4855 10.774 33.4855 5.08353C33.4855 3.06023 33.4602 3.03494 31.3864 3.03494C22.2309 3.03494 13.0755 3.03494 3.92013 3.03494C3.64193 3.03494 3.38902 3.03494 3.08552 3.03494V72.9145ZM52.808 21.2446C48.205 14.8712 42.8685 9.53477 36.5458 4.98236V21.2446H52.808Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_218_1410"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.8409,
    height: 76,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.c8f3faee.svg";
export { ForwardRef as ReactComponent };